import { useMemo } from "react";
import { Grid, Select } from "@mantine/core";
import { PortalSubjectType } from "../../../services/admin/portalAccess.service";
import { HALF_ROW_SPAN } from "./portalGrantLayout";

interface SubjectOption {
  value: string;
  label: string;
}

export interface SubjectSelectFieldsProps {
  subjectType: PortalSubjectType | "";
  subjectId: string;
  subjectOptions: SubjectOption[];
  onSubjectTypeChange: (value: string | null) => void;
  onSubjectIdChange: (value: string | null) => void;
}

const SUBJECT_TYPE_OPTIONS: Array<{ value: PortalSubjectType; label: string }> =
  [
    { value: "physician", label: "Physician" },
    { value: "practice", label: "Practice" },
    { value: "surgery_center", label: "Surgery Center" },
  ];

export function SubjectSelectFields({
  subjectType,
  subjectId,
  subjectOptions,
  onSubjectTypeChange,
  onSubjectIdChange,
}: SubjectSelectFieldsProps) {
  const subjectPlaceholder = useMemo(
    () => (subjectType ? "Choose a subject" : "Pick a subject type first"),
    [subjectType]
  );

  return (
    <Grid gutter="md">
      <Grid.Col span={HALF_ROW_SPAN}>
        <Select
          label="Subject type"
          placeholder="Choose subject type"
          data={SUBJECT_TYPE_OPTIONS}
          value={subjectType || null}
          onChange={onSubjectTypeChange}
          withAsterisk
        />
      </Grid.Col>
      <Grid.Col span={HALF_ROW_SPAN}>
        <Select
          label="Subject"
          placeholder={subjectPlaceholder}
          data={subjectOptions}
          value={subjectId || null}
          onChange={onSubjectIdChange}
          disabled={!subjectType}
          searchable
          withAsterisk
        />
      </Grid.Col>
    </Grid>
  );
}
